export default __webpack_public_path__ + "static/media/noun_Scanner_1777009.e86c1f1c.svg";